import { createAsyncThunk } from '@reduxjs/toolkit'

import Axios from '../axios'
import { serialize, deserialize } from '../utility/serialization'
import { handleAPIError } from '../utility/actionHelper'
import { refreshCurrentUser } from './userActions'

const CERTIFICATIONS_URL = '/api/v1/coach/certifications'

const enrollmentUrl = (state) => `${CERTIFICATIONS_URL}/enrollments/${state.coachCertification.certification.enrollment.id}`

const request = async (call, rejectWithValue) => {
  try {
    const { data } = await call()
    return deserialize(data)
  } catch (error) {
    return handleAPIError(error, rejectWithValue)
  }
}

const requestAndReload = async (call, { dispatch, getState, rejectWithValue }) => {
  const certificationId = getState().coachCertification.certification.id
  try {
    const { data } = await call()
    if (getState().coachCertification.requestedId === certificationId) { await dispatch(getCoachCertification(certificationId)) }
    return deserialize(data)
  } catch (error) {
    return handleAPIError(error, rejectWithValue)
  }
}

export const getCoachCertifications = createAsyncThunk(
  'coachCertification/getCoachCertifications',
  (_, { rejectWithValue }) => request(() => Axios.get(CERTIFICATIONS_URL), rejectWithValue)
)

export const getCoachCertification = createAsyncThunk(
  'coachCertification/getCoachCertification',
  (certificationId, { rejectWithValue }) => request(() => Axios.get(`${CERTIFICATIONS_URL}/${certificationId}`), rejectWithValue)
)

export const getCoupon = createAsyncThunk(
  'coachCertification/getCoupon',
  ({ certificationId, code }, { rejectWithValue }) =>
    request(() => Axios.get(`${CERTIFICATIONS_URL}/${certificationId}/coupons/${encodeURIComponent(code)}`), rejectWithValue)
)

export const createEnrollment = createAsyncThunk(
  'coachCertification/createEnrollment',
  ({ certificationId, couponCode }, thunkApi) =>
    requestAndReload(() => Axios.post(`${CERTIFICATIONS_URL}/${certificationId}/enrollment`, serialize({ couponCode })), thunkApi)
)


export const createCheckout = createAsyncThunk(
  'coachCertification/createCheckout',
  ({ certificationId, couponCode }, { rejectWithValue }) =>
    request(() => Axios.post(`${CERTIFICATIONS_URL}/${certificationId}/checkout`, serialize({ couponCode })), rejectWithValue)
)

export const confirmCheckout = createAsyncThunk(
  'coachCertification/confirmCheckout',
  async (hostedPageId, { rejectWithValue }) => {
    try {
      const { status, data } = await Axios.get(`${CERTIFICATIONS_URL}/checkouts/${hostedPageId}`)
      return { pending: status === 202, ...deserialize(data || {}) }
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const generateKit = createAsyncThunk(
  'coachCertification/generateKit',
  (enrollmentId, thunkApi) => requestAndReload(() => Axios.post(`${CERTIFICATIONS_URL}/enrollments/${enrollmentId}/kit`), thunkApi)
)

export const completeLesson = createAsyncThunk(
  'coachCertification/completeLesson',
  (lessonId, thunkApi) =>
    requestAndReload(() => Axios.post(`${enrollmentUrl(thunkApi.getState())}/lesson_completions`, { lesson_id: lessonId }), thunkApi)
)

export const submitQuizAttempt = createAsyncThunk(
  'coachCertification/submitQuizAttempt',
  async ({ quizId, answers }, { dispatch, getState, rejectWithValue }) => {
    try {
      const { data } = await Axios.post(`${enrollmentUrl(getState())}/quiz_attempts`, { quiz_id: quizId, answers })
      const { certification } = await dispatch(getCoachCertification(getState().coachCertification.certification.id)).unwrap()
      if (certification.enrollment?.status === 'completed') { await dispatch(refreshCurrentUser(getState().user.current_user.id)) }
      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)
